import { render, staticRenderFns } from "./CustomGameCard.vue?vue&type=template&id=1c9359ca&scoped=true&"
import script from "./CustomGameCard.vue?vue&type=script&lang=js&"
export * from "./CustomGameCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomGameCard.vue?vue&type=style&index=0&id=1c9359ca&scoped=true&lang=css&"
import style1 from "./CustomGameCard.vue?vue&type=style&index=1&id=1c9359ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9359ca",
  null
  
)

export default component.exports